import React from 'react';
import {Row, Col} from 'reactstrap';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';

const TimeSlotSelection = (props) => {
  return (
    <div className='setup-address component-container'>
      <Row>
        <Col ms={12}>
          <div className={'setup-address-container'}>
            <div className={'title-area'}>
              <span className={'setup-address-title'}>תאום יום ושעה</span>
              <span className={'setup-address-subTitle'}>יש חלונות זמן קבועים עבור הגעת שליח</span>
            </div>
            <ReactSelect
              inputProps={{readOnly: true}}
              isSearchable={false}
              error={props.error}
              getOptionLabel={(option) => option.value}
              getOptionValue={(option) => option.key}
              placeholder={'לבחירת מועד'}
              isLoading={false}
              value={props.timeSlots?.filter((option) => option.key === props.selected)}
              name={props.name}
              options={props.timeSlots}
              onChange={(e) => props.changeHandler(e)}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TimeSlotSelection;
